import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isDocumentRequestEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'Portals.DocumentRequestFlow',
    false,
  )
}
